const CHANGE = 'CHANGE';
const CHANGE_DEADLINE = 'CHANGE_DEADLINE';
const SHOW_RESULTS = 'SHOW_RESULTS';
const DELETE = 'DELETE';
const ASSIGNMENT_ACTION_BEGIN = 'ASSIGNMENT_ACTION_BEGIN';
const ASSIGNMENT_ACTION_END = 'ASSIGNMENT_ACTION_END';
const CLOSE = 'CLOSE';

module.exports = {
	CHANGE,
	CHANGE_DEADLINE,
	SHOW_RESULTS,
	DELETE,
	ASSIGNMENT_ACTION_BEGIN,
	ASSIGNMENT_ACTION_END,
	CLOSE
};
